<template>
    <img :src="src" class="img-fluid">
</template>

<script>
    export default {
        name: "ImageViewer",
        props: {
            src: {
                required: true,
                type: String
            }
        }
    }
</script>

<style scoped>

</style>
